import { FC } from "react";
import svgIcons from "../../../assets/svg/svgIcons";
import { getUserIntials } from "../../../utils/string";

type TChatAvatarProps = {
  isGroupChat?: boolean;
  isMe?: boolean;
  title: string;
}

const ChatAvatar: FC<TChatAvatarProps> = ({
  isGroupChat = false,
  isMe = false,
  title
}) => {
  const userInitials = getUserIntials(title);
  return (
    <span className="flex-shrink-0">
      {isGroupChat ? (
        <img
          className="bg-accent-blue-pale rounded-full size-10 p-2"
          src={svgIcons.GroupChatIcon}
          alt="Group Chat"
        />
      ) : (
        <img
          className="bg-black/10 h-10 w-10 rounded-full"
          src={`https://ui-avatars.com/api/?name=${userInitials}&background=${isMe ? 'DDDDDD' : 'random'}&size=256`}
          alt={title}
        />
      )}
    </span>
  )
}
export default ChatAvatar;